<template>
  <!-- 推广活动标签导航 -->
  <div class="tab-nav">
    <el-button round size="small" :class="{ 'is-active-tab': changetype == 1 }" @click="switchType(1)">中文网</el-button>
    <el-button round size="small" :class="{ 'is-active-tab': changetype == 2 }" @click="switchType(2)">英文网</el-button>
    <el-button round size="small" :class="{ 'is-active-tab': changetype == 3 }" @click="switchType(3)">培训</el-button>
    <el-button round size="small" :class="{ 'is-active-tab': changetype == 5 }" @click="switchType(5)">东南亚论坛配对会</el-button>
    <el-button round size="small" :class="{ 'is-active-tab': changetype == 6 }" @click="switchType(6)">新媒体</el-button>
    <el-button round size="small" :class="{ 'is-active-tab': changetype == 7 }" @click="switchType(7)">轴承网</el-button>
    <el-button round size="small" :class="{ 'is-active-tab': changetype == 8 }" @click="switchType(8)">Facebook</el-button>
  </div>
</template>

<script>
export default {
  name: "promotionTop",
  data() {
    return {
      changetype: 1,
    };
  },
  mounted() {
    this.changetype = this.$route.query.type || "1";
  },
  methods: {
    switchType(id) {
      this.changetype = id;
      this.$router.push({ name: "promotion", query: { type: String(id) } });
    },
  },
};
</script>

<style scoped>
.is-active-tab {
  background-color: var(--color-primary, #1a73e8);
  color: white;
  border-color: var(--color-primary, #1a73e8);
}
</style>



// WEBPACK FOOTER //
// src/components/links/promotion_Top.vue